import axios from 'axios';
import store from '@stores';

const token = localStorage.getItem('x-access-token');
let config = {
  baseURL: process.env.VUE_APP_API_URL || process.env.baseURL || '',
  headers: {
    common: {
      Accept: 'application/json',
    },
  },
};

export const api = axios.create(config);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    try {
      if (
        error.response.status === 401 &&
        !error.request.responseURL.includes('/login') &&
        !error.request.responseURL.includes('/me') &&
        !error.request.responseURL.includes('/logout')
      ) {
        $showError(
          'Your session has expired. Please login again.',
          'auth-toast'
        );
        window.$error401 = true;
        setTimeout(() => {
          delete window.$error401;
        }, 1000);
        resetAuthToken();
        if (store.state.auth.user) {
          $bus.$emit('session-expired');
        } else {
          $router.push({
            name: 'login',
          });
        }
      }
    } catch (e) {
      //
    }
    return Promise.reject(error);
  }
);

if (token) {
  setAuthToken(token);
}

export default api;

export function setAuthToken(token) {
  api.defaults.headers.common['Authorization'] = 'Bearer ' + token;
  localStorage.setItem('x-access-token', token);
}

export function resetAuthToken() {
  delete api.defaults.headers.common['Authorization'];
  localStorage.removeItem('x-access-token');
}
